import { clsx } from 'clsx';
import type { HTMLAttributes } from 'react';
import { forwardRef } from 'react';

import s from './XText.module.less';
import { XTextColor, XTextType } from './XText.types';

interface Props extends HTMLAttributes<Omit<HTMLSpanElement, 'color'>> {
  className?: string;
  color?: XTextColor;
  crossed?: boolean;
  semibold?: boolean;
  bold?: boolean;
  nowrap?: boolean;
  type?: XTextType;
  underline?: boolean;
  capitalize?: boolean;
  breakAll?: boolean;
  ellipsis?: boolean;
  whiteSpacePreWrap?: boolean;
}

export const XText = forwardRef<HTMLSpanElement, Props>(
  (
    {
      className,
      color,
      crossed,
      semibold,
      bold,
      nowrap,
      type,
      underline,
      capitalize,
      breakAll,
      ellipsis,
      whiteSpacePreWrap,
      ...props
    },
    ref,
  ) => {
    return (
      <span
        ref={ref}
        className={clsx(
          breakAll && s.breakAll,
          ellipsis && s.ellipsis,
          color ? s[color] : undefined,
          crossed && s.crossed,
          semibold && s.semibold,
          bold && s.bold,
          type && s[type],
          underline && s.underline,
          capitalize && s.capitalize,
          whiteSpacePreWrap && s.whiteSpacePreWrap,
          nowrap && s.nowrap,
          className,
        )}
        {...props}
      />
    );
  },
);

XText.displayName = 'XText';
